'use strict';


function find(array, fn) {
	for (var i = 0, count = array.length; i < count; i++) {
		if (fn(array[i])) {
			return {index: i, value: array[i]};
		}
	}
	return {index: -1};
}


export function findByKeyValue(array, key, value) {
	return find(array, (obj) => {
		return obj[key] === value;
	});
}


export function findByEquality(array, obj) {
	return find(array, angular.equals.bind(null, obj));
}


export function findByUUID(array, uuid) {
	return find(array, function(obj) {
		return (obj.uuid == uuid);
	});
}
